import React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
import { useRiskRelatedForms } from 'hooks/risks'
// components
import {
  AiChatButton,
  ExportButton,
  RiskFunctions,
  RelatedFormButtons,
  ScheduleFormButton,
  ChangeVisibilityButton,
  ShowArchivedFormsButton,
  MultipleRelatedFormButtons
} from 'components/CTAs'
// context
import { RiskAPIContext } from 'containers/Risks/Risk/Edit/layers/API'
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'

const RiskCTA: React.FC = () => {
  const router = useRouter()

  const { risk, updateRisk } = React.useContext(RiskAPIContext)
  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const { parentRelatedForm } = useRiskRelatedForms()

  const isMultipleRelatedForm = !!router.query.multiple
  const isRelatedForm = !isMultipleRelatedForm && !!parentRelatedForm

  return (
    <>
      {!isMultipleRelatedForm && <AiChatButton />}
      {!isMultipleRelatedForm && <RiskFunctions />}
      {isMultipleRelatedForm && <MultipleRelatedFormButtons />}
      {isRelatedForm && <RelatedFormButtons />}
      {risk?.recurrence && <ScheduleFormButton />}
      {!isMultipleRelatedForm && !isRelatedForm && (
        <ChangeVisibilityButton
          entity={risk}
          entityType='form'
          onSetVisibility={updateRisk}
          disabled={!risk?.permissions?.riskSetSecurity}
        />
      )}
      {!isMultipleRelatedForm && <ExportButton />}
      {!isMultipleRelatedForm && riskTemplate.archiveOnDelete && <ShowArchivedFormsButton />}
    </>
  )
}

export default RiskCTA
